import { DataTableColumnHeader } from "../table-components/data-table-column-header";

export const serviceColumns = [
  {
    id: "service",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Service Type" />
    ),
    accessorFn: (row) => row.serviceDetail?.service || "N/A",
  },
  {
    id: "serviceEquipment",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Service Equipment" />
    ),
    accessorFn: (row) =>
      row.serviceDetail?.serviceEquipment?.join(", ") || "N/A",
    cell: (info) => (
      <div className="line-clamp-2 min-w-32">{info.getValue()}</div>
    ),
  },
  {
    id: "serviceInstruction",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Service Instructions" />
    ),
    accessorFn: (row) =>
      row.serviceDetail?.serviceInstruction?.join(" ") || "N/A",
    cell: (info) => (
      <div className="line-clamp-2 min-w-32">{info.getValue()}</div>
    ),
  },
  {
    id: "shoveller",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Shoveller" />
    ),
    accessorFn: (row) => {
      const sh = row.ShovelerInfo?.[0]?.ShovelerId;
      return sh
        ? {
          name: `${sh.firstName || "N/A"} ${sh.lastName || "N/A"}`,
          username: sh.userName || "N/A",
        }
        : { name: "N/A", username: "N/A" };
    },
    cell: (info) => (
      <div>
        <div className="whitespace-nowrap">{info.getValue().name}</div>
        <div style={{ fontSize: "0.85em", color: "#666" }}>
          {info.getValue().username}
        </div>
      </div>
    ),
    filterFn: (row, columnId, filterValue) => {
      const sh = row.original.ShovelerInfo?.[0]?.ShovelerId;
      if (!sh) return false;
      const name = `${sh.firstName || ""} ${sh.lastName || ""}`.toLowerCase();
      const username = (sh.userName || "").toLowerCase();
      const filter = filterValue.toLowerCase();
      return name.includes(filter) || username.includes(filter);
    },
  },
  {
    id: "shovellerContact",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Shoveller Contact" />
    ),
    accessorFn: (row) => {
      const sh = row.ShovelerInfo?.[0]?.ShovelerId;
      return {
        email: sh?.email || "N/A",
        phone: sh?.phone || "N/A",
      };
    },
    cell: (info) => (
      <div>
        <div className="whitespace-nowrap text-xs">{info.getValue().email}</div>
        <div style={{ fontSize: "0.75em", color: "#666" }}>
          {info.getValue().phone}
        </div>
      </div>
    ),
  },
  {
    id: "shovellerAction",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Shoveller Action" />
    ),
    accessorFn: (row) => row.ShovelerInfo?.[0]?.shovellerAction || "N/A",
  },
  {
    id: "houseOwnerAction",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="House Owner Action" />
    ),
    accessorFn: (row) => row.ShovelerInfo?.[0]?.houseOwnerAction || "N/A",
  },
  {
    id: "requestedTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Requested Time" />
    ),
    accessorFn: (row) =>
      row.ShovelerInfo?.[0]?.requestedTime
        ? new Date(row.ShovelerInfo[0].requestedTime).toLocaleString("en-US")
        : "N/A",
  },
];
